var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneOnNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.8555C11.3604 11.8555 12.2764 10.8369 12.2764 9.38086V4.80762C12.2764 3.34473 11.3604 2.33301 10 2.33301C8.63281 2.33301 7.7168 3.34473 7.7168 4.80762V9.38086C7.7168 10.8369 8.63281 11.8555 10 11.8555ZM5.10547 9.49023C5.10547 12.1699 6.87598 14.0498 9.48047 14.2686V15.8613H6.94434C6.65723 15.8613 6.4248 16.0938 6.4248 16.3809C6.4248 16.668 6.65723 16.8936 6.94434 16.8936H13.0488C13.3359 16.8936 13.5684 16.668 13.5684 16.3809C13.5684 16.0938 13.3359 15.8613 13.0488 15.8613H10.5127V14.2686C13.124 14.0498 14.8877 12.1699 14.8877 9.49023V8.10254C14.8877 7.81543 14.6621 7.58984 14.375 7.58984C14.0879 7.58984 13.8555 7.81543 13.8555 8.10254V9.44922C13.8555 11.7803 12.3379 13.3252 10 13.3252C7.65527 13.3252 6.1377 11.7803 6.1377 9.44922V8.10254C6.1377 7.81543 5.91211 7.58984 5.61816 7.58984C5.33105 7.58984 5.10547 7.81543 5.10547 8.10254V9.49023Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOnNew);
export default __webpack_public_path__ + "static/media/microphone-on-new.a68c0398.svg";
export { ForwardRef as ReactComponent };